import { render, staticRenderFns } from "./FormChildTemplateSelectorModal.vue?vue&type=template&id=2ff3bb27"
import script from "./FormChildTemplateSelectorModal.vue?vue&type=script&lang=js"
export * from "./FormChildTemplateSelectorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports